import { useCallback } from 'react';
import { useRxData } from 'rxdb-hooks';

import { RxdbCollectionName } from '../rxdbCollectionName';
import type {
  WorkPackageFiles,
  WorkPackageFilesCollection,
} from './workPackageFiles.types';

const useSelectedWorkPackageFile = (workPackageId: string) => {
  const getWorkPackageFileQuery = useCallback(
    (collection: WorkPackageFilesCollection) =>
      collection?.find({
        selector: { workPackageId },
      }),
    [workPackageId],
  );

  const { result, isFetching: isWPFileLoading } = useRxData<WorkPackageFiles>(
    RxdbCollectionName.WORK_PACKAGE_FILES,
    getWorkPackageFileQuery,
  );

  return { workPackageFiles: result, isWPFileLoading };
};

export default useSelectedWorkPackageFile;
